import { motion } from "framer-motion";
import { memo, useCallback, useState } from "react";
import { IDashboardFiltersProps } from "./models";
import { Button, ISelectType } from "@4uhub/lib4uhub";
import { Box } from "@mui/material";
import DashboardCustomizeRoundedIcon from "@mui/icons-material/DashboardCustomizeRounded";
import { Header } from "./Header/Header";
import { FiltersList } from "./FiltersList/FiltersList";
import { IDashboardFilters } from "../../../../../models/dashboard";
import { useTranslation } from "react-i18next";

const TRANSLATION_PATH = "components.panel.";

export const DashboardFilters = memo(
  ({
    dashboard,
    filters,
    loading,
    onBackHandler,
    onCreateDashboard,
  }: IDashboardFiltersProps) => {
    const { t } = useTranslation();

    const [filtersList, setFiltersList] = useState<IDashboardFilters>({
      ticketChannels: [],
      ticketCustomerServiceTypes: [],
      ticketServices: [],
      ticketTypes: [],
      ticketWorkspaces: [],
    });

    const createHandler = useCallback(() => {
      onCreateDashboard(dashboard.id, filtersList);
    }, [filtersList, dashboard.id, onCreateDashboard]);

    const changeFiltersHandler = useCallback(
      (key: string, value: ISelectType[]) => {
        setFiltersList((prev) => ({
          ...prev,
          [key]: value,
        }));
      },
      []
    );

    return (
      <motion.div
        key={dashboard.id}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, ease: [0.6, -0.05, 0.01, 0.99] }}
      >
        <Header name={dashboard.name} onBack={onBackHandler} />
        <FiltersList
          filters={filters}
          filtersList={filtersList}
          onChangeFiltersHandler={changeFiltersHandler}
        />
        <Box sx={{ display: "flex", justifyContent: "end" }}>
          <Button
            variant="contained"
            loading={loading}
            startIcon={<DashboardCustomizeRoundedIcon />}
            onClick={createHandler}
          >
            {t(TRANSLATION_PATH + "add_dashboard")}
          </Button>
        </Box>
      </motion.div>
    );
  }
);
